import api from "../api/configAxios";
import Controller from "../common/controller";

export const checkEmail = async (endpoint, email, token) => {
  try {
    var response = await api.get(
      `${Controller.Email}/${endpoint}?email=${email}&token=${token}`
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error);
  }
};
